<div fxLayout="row" class="main-wrapper gravel-calc-type" *ngIf="items.length > 0" style="margin-top:-20px;">
    <form [formGroup]="enumDropdownForm" fxFlexFill fxFlex.gt-sm="100" fxFlex.xs="100">
      <mat-label class="mat-form-field-label-dropdown"> {{ "gravel-calc-type-dropdown.title" | translate }} </mat-label>
    <ng-multiselect-dropdown
    appFocusOnClick
    [placeholder]=placeholder
    [settings]="dropdownSettings"
    [data]="items"
    [(ngModel)]="selectedItems"
    (onSelect)="onSelect($event)"
    (onSelectAll)="onSelectAll($event)"
    (onDeSelect)="onItemDeSelect($event)"
    id="selected"
    formControlName="selected"
    name="selected"
  >
  </ng-multiselect-dropdown>
  <mat-error class="dropdown-error" *ngIf="enumDropdownForm.touched && !singleSelection && enumDropdownForm.controls['selected'].errors?.['required']">
    {{ "error.required_gravel-calc-types" | translate }}
  </mat-error>
  <mat-error class="dropdown-error" *ngIf="enumDropdownForm.touched && singleSelection && enumDropdownForm.controls['selected'].errors?.['required']">
    {{ "error.required_gravel-type" | translate }}
  </mat-error>
  </form>
  </div>
